import {useState,useEffect} from 'react'
import {useSelector,useDispatch} from 'react-redux'
import {toggleSharedClientRestrictions} from './settingsSlice'
import Form from "react-bootstrap/Form"
import Col from "react-bootstrap/Col"
import Card from "react-bootstrap/Card"
import Row from "react-bootstrap/Row"
import Spinner from "react-bootstrap/Spinner"
import classes from "./Settings.module.css"

const GymResources = ()=>{
	const dispatch = useDispatch()
	const sharedClientRestrictionsOn = useSelector(state=>state.settings.gymResourceSettings.shared_client_restrictions === 1)

	const handleToggleSharedClientRestrictions = () => {
		dispatch(toggleSharedClientRestrictions())
	}
	
	return (
		<Card className={`${classes.cardWidth} mb-5 shadow px-5`}>
			<Card.Body>
				<h4>Gym Resources</h4>
				<p>Here you can control what resources trainers can use with shared clients.</p>
				<hr/>
				<Row className="mb-3">
					<Col>
						<small>
							When the following setting is disabled shared clients can only have resources (eg workouts/tasks/nutrition)
							assigned to them <em>from the gym libraries</em>. This prevents one trainer's edits from potentially affecting
							the work of another. 
						</small>
					</Col>
				</Row>
				<Row className="d-flex align-items-center justify-content-center mb-3">
					<Col>
						<div className="d-flex align-items-center">
							Shared Client Restrictions
								<small 
									className={[
										sharedClientRestrictionsOn?'text-success':'text-danger',
										'ml-1'
									].join(' ')}
								>
									({sharedClientRestrictionsOn?'on':'off'})
								</small>
						</div>
					</Col>
					<Col >
						<Form.Group className="mb-0" controlId="restrict-to-gym">
							<Form.Check 
								className="" 
								onChange={handleToggleSharedClientRestrictions}
								checked={sharedClientRestrictionsOn} 
								type="checkbox" 
								className="custom-control 
								custom-checkbox"
							/>
						</Form.Group>
					</Col>
				</Row>
				{!sharedClientRestrictionsOn&&
					<Row>
						<Col>
							<small className="text-danger">
								WARNING: make sure all trainers know that updating/deleting resources (eg exercises & food) could
								unexpectedly affect workouts/tasks/nutrition for shared clients. 
							</small>
						</Col>
					</Row>
				}
			</Card.Body>
		</Card>
	)
}

export default GymResources